// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4283 ? "fe680085" : chunkId) + "." + {"4283":"5608e7cb04dc498a","8686":"517e3200713a618f"}[chunkId] + ".js";
};